/* eslint no-unsafe-optional-chaining: "error" */
import clsx from 'clsx';
import React, { memo } from 'react';
import { parseDiscountItem } from '../../../utils/helpers';
import styles from './PromotinalTag.module.scss';
import { PromotinalTagProps, TagData } from './PromotinalTagType';



const PromotinalTag: React.FC<PromotinalTagProps> = ({ 
  data = {} as TagData, 
  placement = '', 
  gridType = '', 
  isFromFrontastic = false 
}) => {
  if (!data) return null;

  const renderTag = (name: string, color?: string, bgColor?: string, borderColor?: string) => (
    <span
      className={clsx(styles.promotinalTag, {
        [styles.gridWide]: gridType === 'wide',
        [styles.gridNarrow]: gridType === 'narrow',
        [styles[`placement_${placement}`]]: placement,
      })}
      style={{
        color: color,
        backgroundColor: bgColor,
        borderColor: borderColor,
      }}
    >
      {name}
    </span>
  );

  // Frontastic DPM type
  if (isFromFrontastic) {
    const { name, color, bgColor } = data;
    return name ? <div className={styles.promotinalTagWrapper}>{renderTag(name, color, bgColor)}</div> : null;
  }

  // CT parse data;
  const { name, color, bgColor, borderColor } = parseDiscountItem(data);
  return name ? renderTag(name, color, bgColor, borderColor) : null;
};

export default memo(PromotinalTag);
